import React, { useState, useRef, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Image from '../Common/Image';

const ApprovedSupplierContainer = () => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const scollToRef = useRef();

    const handleSelect = index => {
        setSelectedIndex(index);
    };

    const btnHandleClick = () => {
        if (selectedIndex !== 1) {
            setSelectedIndex(1);
        }
        setTimeout(() => {
            if (scollToRef.current) {
                scollToRef.current.scrollIntoView();
            }
        }, 100);
    };

    return (
        <main className="re-approved-supplier-program">
            <section className="re-approved-supplier-program-section-1">
                <div className="re-approved-supplier-program-section-1-container">
                    <h1 className="re-marketing-grey re-marketing-header-text">THE RESAAS</h1>
                    <h1 className="re-marketing-yellow re-marketing-header-text">
                        <span className="re-bold">APPROVED SUPPLIER </span>
                        <span className="re-hollow-darkest">PROGRAM</span>
                    </h1>
                    <button className="re-marketing-btn" onClick={btnHandleClick}>
                        Become an Approved Supplier
                    </button>
                </div>
            </section>
            <section className="re-approved-supplier-program-section-2">
                <div className="re-approved-supplier-program-section-2-container">
                    <p>
                        RESAAS offers <span className="re-marketing-yellow">advertising opportunities</span> for a
                        limited number of partners to ensure{' '}
                        <span className="re-marketing-pink">maximum brand exposure</span> and quality of product in
                        front of agents.
                    </p>
                </div>
            </section>
            <Tabs selectedIndex={selectedIndex} onSelect={handleSelect}>
                <TabList>
                    <Tab data-testid="approvedsupplier">{`RESAAS APPROVED SUPPLIERS`}</Tab>
                    <Tab data-testid="becomeapprovedsupplier">{`BECOME AN APPROVED SUPPLIER`}</Tab>
                </TabList>
                <TabPanel>
                    <ul className="re-approved-supplier-list">
                        <li className="re-approved-supplier-brand">
                            <Image
                                src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/386826b2-1f83-4a54-a79a-0118100626a5.png"
                                alt="Blimp Homes"
                                width={198}
                                height={73}
                            />
                            <article>
                                <h2>Blimp Homes</h2>
                                <p>
                                    Blockchain has reached the Real Estate Industry, with the introduction of HOME
                                    Tokens to reward agents for your contributions for anything from posting a listing
                                    to creating a referral. HOME Tokens are a form of Blockchain currency managed by The
                                    Home Network Foundation which shares the value of the transaction between token
                                    holders. Your RESAAS membership will give you 100 FREE Home Tokens.
                                </p>
                                <a
                                    className="re-approved-supplier-more-info"
                                    href="https://blimphomes.com/"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    {`Find out more`} <span className="re-icon re-icon-angle-right" />
                                </a>
                            </article>
                        </li>
                        <li className="re-approved-supplier-brand">
                            <Image
                                src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/1478bf99-8388-4bc3-998d-d1f4f94403d3.png"
                                alt="Golf Life Navigators"
                                width={198}
                                height={64}
                            />
                            <article>
                                <h2>Golf Life Navigators</h2>
                                <p>
                                    You can now specialize in residential real estate sales at golf clubs & communities.
                                    RESAAS has partnered with Golf Life Navigators’ Certified Real Estate Agent Program
                                    to bring RESAAS Premium and Ultimate agents an exclusive 20% discount on this new
                                    certification. Use code: GLN20.
                                </p>
                                <a
                                    className="re-approved-supplier-more-info"
                                    href="https://golflifenavigators.com/"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    {`Find out more`} <span className="re-icon re-icon-angle-right" />
                                </a>
                            </article>
                        </li>
                        <li className="re-approved-supplier-brand">
                            <Image
                                src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/a5b11d61-c944-4cea-a6b4-59e577f153c2.png"
                                alt="Pacaso"
                                width={178}
                                height={66}
                            />
                            <article>
                                <h2>Pacaso</h2>
                                <p>
                                    Reach new buyers and earn 3% referral commission. Agents are buzzing about Pacaso,
                                    the modern way to buy a second home. Learn how co-ownership can help you earn more,
                                    reach new buyers and delight clients.
                                </p>
                                <a
                                    className="re-approved-supplier-more-info"
                                    href="https://www.pacaso.com/"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    {`Find out more`} <span className="re-icon re-icon-angle-right" />
                                </a>
                            </article>
                        </li>
                        <li className="re-approved-supplier-brand">
                            <Image
                                src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/d544063e-2ef6-456d-ac73-11cb6b14c180.png"
                                alt="PIVO"
                                width={250}
                                height={43}
                            />
                            <article>
                                <h2>PIVO</h2>
                                <p>
                                    Pivo, the only tool you need to enhance every part of the sale. What if you could
                                    create videos and 3D tours, give listing presentations and host client video calls
                                    with just ONE tool? Learn more about how Pivo Real Estate can elevate your business
                                    today! Get 10% off your purchase with RESAAS10 at checkout.
                                </p>
                                <a
                                    className="re-approved-supplier-more-info"
                                    href="https://pivo.ai"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    {`Find out more`} <span className="re-icon re-icon-angle-right" />
                                </a>
                            </article>
                        </li>
                        <li className="re-approved-supplier-brand">
                            <Image
                                src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/5563ceb0-0580-4ae2-b8b7-9af09e7a6978.png"
                                alt="Roomvu"
                                width={157}
                                height={21}
                            />
                            <article>
                                <h2>Roomvu</h2>
                                <p>
                                    Local, Timely Real Estate Content Posted For You. We know content creation is really
                                    hard, we scour the web and find local content and post it for you on social media.
                                </p>
                                <a
                                    className="re-approved-supplier-more-info"
                                    href="https://www.roomvustore.com/"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    {`Find out more`} <span className="re-icon re-icon-angle-right" />
                                </a>
                            </article>
                        </li>
                        <li className="re-approved-supplier-brand">
                            <Image
                                src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/7c0775e2-db3f-48ac-8f03-741b224efc14.jpg"
                                alt="VIU by HUB"
                                width={300}
                                height={150}
                            />
                            <article>
                                <h2>VIU by HUB</h2>
                                <p>
                                    Trust VIU by HUB with your buyers' insurance needs and close deals faster –
                                    increasing your revenue. VIU by HUB closes the insurance protection gap by making it
                                    easier for your buyers to purchase needed coverage with the benefits of choice,
                                    efficiency, price transparency and trusted brokerage advice. This is a major step
                                    toward simplifying the insurance understanding and buying process as well as
                                    elevating the digital consumer experience.
                                </p>
                                <a
                                    className="re-approved-supplier-more-info"
                                    href="https://sp.viubyhub.com/RESAAS"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    {`Find out more`} <span className="re-icon re-icon-angle-right" />
                                </a>
                            </article>
                        </li>
                    </ul>
                </TabPanel>
                <TabPanel>
                    <section className="re-approved-supplier-program-section-3">
                        <div className="re-approved-supplier-program-section-3-container">
                            <h2 className="re-approved-supplier-program-section-3-title">WHY RESAAS?</h2>
                            <div className="re-approved-supplier-program-section-3-content">
                                <ul className="re-approved-supplier-program-section-3-desc">
                                    <li className="re-marketing-dark-yellow">
                                        500,000+<span> Members</span>
                                    </li>
                                    <li className="re-marketing-dark-pink">
                                        89,000+<span> Followers on Social Media</span>
                                    </li>
                                    <li className="re-marketing-dark-blue">
                                        22+<span> Languages</span>
                                    </li>
                                </ul>
                                <div className="re-approved-supplier-program-section-3-img">
                                    <Image
                                        src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/9db059be-fe82-4771-8d40-68325e6c4a14.jpg"
                                        alt="WHY RESAAS"
                                        width={342}
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="re-approved-supplier-program-section-4">
                        <div className="re-approved-supplier-program-section-4-container">
                            <div className="re-approved-supplier-program-section-4-title-with-arrow">
                                <span className="re-approved-supplier-program-arrow re-marketing-dark-pink" />
                                <div className="re-approved-supplier-program-section-4-title re-marketing-pink">
                                    ADVERTISING OPPORTUNITIES INCLUDE:
                                </div>
                            </div>
                            <div className="re-approved-supplier-program-section-4-content">
                                <div className="re-approved-supplier-program-section-4-img">
                                    <Image
                                        src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/763a03b0-290a-4e62-92cf-a0aa9fd16d2e.jpg"
                                        alt="ADVERTISING OPPORTUNITIES"
                                        width={400}
                                    />
                                </div>
                                <div className="re-approved-supplier-program-section-4-desc">
                                    <div className="re-approved-supplier-program-section-4-list">
                                        <div className="re-approved-supplier-program-section-4-list-item">
                                            <div className="re-approved-supplier-program-section-4-icon re-marketing-blue">
                                                <Image
                                                    src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/200a0867-4b50-4648-b5e7-90ec21740c49.png"
                                                    className="re-approved-supplier-program-section-4-icon-img1"
                                                    alt="Platform Adverts"
                                                    width={40}
                                                />
                                            </div>Platform Adverts
                                        </div>
                                        <div className="re-approved-supplier-program-section-4-list-item">
                                            <div className="re-approved-supplier-program-section-4-icon re-marketing-pink">
                                                <Image
                                                    src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/88cb3929-ef67-4efc-a415-c3bd802f9b6f.png"
                                                    className="re-approved-supplier-program-section-4-icon-img2"
                                                    alt="Social Media"
                                                    width={40}
                                                />
                                            </div>Social Media
                                        </div>
                                        <div className="re-approved-supplier-program-section-4-list-item">
                                            <div className="re-approved-supplier-program-section-4-icon re-marketing-yellow">
                                                <Image
                                                    src="https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/ebdf1708-ef70-4288-a4b8-7daa37b92af1.png"
                                                    className="re-approved-supplier-program-section-4-icon-img3"
                                                    alt="Email"
                                                    width={40}
                                                />
                                            </div>Email
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="re-approved-supplier-program-section-5">
                        <div className="re-approved-supplier-program-section-5-container">
                            <span>Complete the form to</span>
                            <h1 className="re-marketing-yellow re-hollow re-hollow-black re-approved-supplier-program-section-5-header">
                                DOWNLOAD THE FULL MEDIA KIT
                            </h1>
                            <iframe
                                className="re-approved-supplier-program-section-5-form"
                                src="https://get.resaas.com/download-full-media-kit-form"
                                scrolling="no"
                                ref={scollToRef}
                            />
                        </div>
                    </section>
                </TabPanel>
            </Tabs>

            <section className="re-approved-supplier-program-section-6">
                <div className="re-approved-supplier-program-section-6-container">
                    <span className="re-text-md re-approved-supplier-program-section-span">Ready to really</span>
                    <h1 className="re-marketing-yellow re-hollow re-hollow-black re-approved-supplier-program-section-header">GROW YOUR BUSINESS</h1>
                    <h3 className="re-text-md re-approved-supplier-program-section-h3">Take your business to the next level</h3>
                </div>
            </section>
        </main>
    );
};

export default ApprovedSupplierContainer;
